export default __webpack_public_path__ + "static/media/farmer1.ee910a6e.png";